import { render, staticRenderFns } from "./RegistriesAdd.vue?vue&type=template&id=2b4cfb56&"
import script from "./RegistriesAdd.vue?vue&type=script&lang=js&"
export * from "./RegistriesAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports